SupportErrorHelper =
  constructInbentaLoadErrorMessage : () ->
    Error =
      ErrorType : "InbentaNotLoaded"
      Tagline : Groupon.Support.Tagline || {}
      SubCategory : Groupon.Support.ContentModel.getSubCategory() || {}
      Category : Groupon.Support.ContentModel.getCategory() || {}
    errorMessage = "Inbenta Content not loaded for : #{JSON.stringify(Error)}"

  constructFlexibleContactChannelMissingMessage : () ->
    Error =
      ErrorType : "FlexibleContactChannelMissing"
      Tagline : Groupon.Support.Tagline || {}
      SubCategory : Groupon.Support.ContentModel.getSubCategory() || {}
      Category : Groupon.Support.ContentModel.getCategory() || {}

module.exports = SupportErrorHelper
